import { render, staticRenderFns } from "./MainPageVideoFrame.vue?vue&type=template&id=b4d64286"
import script from "./MainPageVideoFrame.vue?vue&type=script&lang=js"
export * from "./MainPageVideoFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports